import { useState, useEffect } from "react";
import api from "../api";
import { useTheme } from "../components/Theme";

const ORANGE = "#E8520A";

const STAGE_COLORS = {
  prospeccao:"#579bfc", contato:"#fdab3d", reuniao:"#66ccff",
  proposta:"#a25ddc", aprovacao:"#e2445c", fechado:"#00c875", perdido:"#98A2B3"
};

const MESES = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
const DIAS  = ["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"];

export default function Calendario({ onAbrirLead }) {
  const { theme } = useTheme();
  const [hoje]    = useState(new Date());
  const [ano,  setAno]  = useState(hoje.getFullYear());
  const [mes,  setMes]  = useState(hoje.getMonth());
  const [leads, setLeads] = useState([]);
  const [selecionado, setSelecionado] = useState(null);

  useEffect(()=>{
    api.get("/leads?limit=1000").then(r=>{
      setLeads((r.data.leads||[]).filter(l=>l.followup?.data));
    }).catch(()=>{});
  },[]);

  const navMes=(d)=>{
    let nm=mes+d, na=ano;
    if(nm<0){nm=11;na--;} if(nm>11){nm=0;na++;}
    setMes(nm); setAno(na);
  };

  // Gerar dias do mês
  const primeiroDia = new Date(ano, mes, 1).getDay();
  const totalDias   = new Date(ano, mes+1, 0).getDate();
  const celulas     = Array.from({length: primeiroDia + totalDias}, (_,i)=>{
    if(i<primeiroDia) return null;
    return i - primeiroDia + 1;
  });

  // Eventos por dia
  const eventosDoDia=(dia)=>{
    if(!dia) return [];
    return leads.filter(l=>{
      if(!l.followup?.data) return false;
      const d=new Date(l.followup.data);
      return d.getFullYear()===ano && d.getMonth()===mes && d.getDate()===dia;
    });
  };

  // Próximos 7 dias
  const proximos = leads
    .filter(l=>{
      if(!l.followup?.data) return false;
      const d=new Date(l.followup.data);
      const diff=(d-hoje)/(1000*60*60*24);
      return diff>=-1 && diff<=7;
    })
    .sort((a,b)=>new Date(a.followup.data)-new Date(b.followup.data));

  // Atrasados
  const atrasados = leads.filter(l=>{
    if(!l.followup?.data||l.followup?.concluido) return false;
    return new Date(l.followup.data) < hoje;
  });

  const diaHoje  = hoje.getDate();
  const mesHoje  = hoje.getMonth();
  const anoHoje  = hoje.getFullYear();

  return (
    <div style={{ padding:24, fontFamily:"'Inter',-apple-system,sans-serif", background:theme.bg, minHeight:"100vh" }}>

      {/* Header */}
      <div style={{ marginBottom:20 }}>
        <h2 style={{ margin:"0 0 4px", fontSize:20, fontWeight:800, color:theme.text, letterSpacing:"-.02em" }}>Calendário</h2>
        <p style={{ margin:0, fontSize:13, color:theme.textMuted }}>Follow-ups e reuniões agendadas</p>
      </div>

      {/* Alertas */}
      {atrasados.length>0&&(
        <div style={{ background:"#feecec", border:"1px solid #f9d3d3", borderRadius:10, padding:"10px 16px", marginBottom:12, fontSize:13, color:"#e2445c", display:"flex", alignItems:"center", gap:8 }}>
          ⚠️ <strong>{atrasados.length} follow-up{atrasados.length>1?"s":""} atrasado{atrasados.length>1?"s":""}:</strong>
          {atrasados.slice(0,3).map(l=>(
            <span key={l._id} onClick={()=>onAbrirLead&&onAbrirLead(l._id)}
              style={{ background:"#feecec", border:"1px solid #f9d3d3", borderRadius:6, padding:"2px 8px", cursor:"pointer", fontWeight:600 }}>
              {l.nome}
            </span>
          ))}
        </div>
      )}

      <div style={{ display:"grid", gridTemplateColumns:"1fr 300px", gap:20 }}>

        {/* Calendário */}
        <div>
          <div style={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:12, overflow:"hidden", boxShadow:theme.shadow }}>

            {/* Header do calendário */}
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"16px 20px", borderBottom:`1px solid ${theme.border}`, background:theme.bgSecond }}>
              <button onClick={()=>navMes(-1)} style={{ background:"none", border:`1px solid ${theme.border}`, borderRadius:8, padding:"6px 12px", color:theme.textMuted, cursor:"pointer", fontSize:16 }}
                onMouseEnter={e=>{ e.currentTarget.style.background=theme.bgInput; e.currentTarget.style.color=theme.text; }}
                onMouseLeave={e=>{ e.currentTarget.style.background="none"; e.currentTarget.style.color=theme.textMuted; }}>‹</button>
              <span style={{ fontSize:16, fontWeight:700, color:theme.text, letterSpacing:"-.01em" }}>
                {MESES[mes].toUpperCase()} {ano}
              </span>
              <button onClick={()=>navMes(1)} style={{ background:"none", border:`1px solid ${theme.border}`, borderRadius:8, padding:"6px 12px", color:theme.textMuted, cursor:"pointer", fontSize:16 }}
                onMouseEnter={e=>{ e.currentTarget.style.background=theme.bgInput; e.currentTarget.style.color=theme.text; }}
                onMouseLeave={e=>{ e.currentTarget.style.background="none"; e.currentTarget.style.color=theme.textMuted; }}>›</button>
            </div>

            {/* Dias da semana */}
            <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", borderBottom:`1px solid ${theme.border}` }}>
              {DIAS.map(d=>(
                <div key={d} style={{ padding:"10px 0", textAlign:"center", fontSize:11, fontWeight:700, color:theme.textMuted, letterSpacing:".06em", textTransform:"uppercase" }}>{d}</div>
              ))}
            </div>

            {/* Grade de dias */}
            <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)" }}>
              {celulas.map((dia, idx)=>{
                const eventos    = eventosDoDia(dia);
                const isHoje     = dia===diaHoje && mes===mesHoje && ano===anoHoje;
                const isSel      = selecionado===dia;
                const temAtrasado = eventos.some(e=>new Date(e.followup.data)<hoje&&!e.followup?.concluido);
                return (
                  <div key={idx} onClick={()=>dia&&setSelecionado(isSel?null:dia)}
                    style={{ minHeight:80, padding:"8px 6px", borderRight:`1px solid ${theme.border}`, borderBottom:`1px solid ${theme.border}`, background:isSel?ORANGE+"12":isHoje?theme.bgInput:"transparent", cursor:dia?"pointer":"default", transition:"background .1s" }}
                    onMouseEnter={e=>{ if(dia&&!isSel) e.currentTarget.style.background=theme.bgHover; }}
                    onMouseLeave={e=>{ e.currentTarget.style.background=isSel?ORANGE+"12":isHoje?theme.bgInput:"transparent"; }}>
                    {dia&&(
                      <>
                        <div style={{ fontSize:13, fontWeight:isHoje?700:400, color:isHoje?ORANGE:theme.textMuted, marginBottom:4 }}>{dia}</div>
                        {eventos.slice(0,2).map((e,i)=>(
                          <div key={i} style={{ fontSize:10, background:(STAGE_COLORS[e.stage]||"#579bfc")+"22", color:STAGE_COLORS[e.stage]||"#579bfc", border:`1px solid ${(STAGE_COLORS[e.stage]||"#579bfc")}44`, borderRadius:4, padding:"2px 5px", marginBottom:2, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontWeight:600 }}>
                            {e.nome}
                          </div>
                        ))}
                        {eventos.length>2&&<div style={{ fontSize:10, color:theme.textMuted }}>+{eventos.length-2}</div>}
                        {temAtrasado&&<div style={{ width:6, height:6, borderRadius:"50%", background:"#e2445c", marginTop:2 }}/>}
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Eventos do dia selecionado */}
          {selecionado&&eventosDoDia(selecionado).length>0&&(
            <div style={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:12, padding:16, marginTop:16 }}>
              <div style={{ fontSize:13, fontWeight:700, color:theme.text, marginBottom:12 }}>
                📅 {selecionado} de {MESES[mes]} — {eventosDoDia(selecionado).length} evento{eventosDoDia(selecionado).length>1?"s":""}
              </div>
              {eventosDoDia(selecionado).map(e=>(
                <div key={e._id} onClick={()=>onAbrirLead&&onAbrirLead(e._id)}
                  style={{ display:"flex", alignItems:"flex-start", gap:12, padding:"10px 12px", borderRadius:8, marginBottom:8, background:theme.bgInput, cursor:"pointer", border:`1px solid ${theme.border}` }}
                  onMouseEnter={ev=>ev.currentTarget.style.background=theme.bgHover}
                  onMouseLeave={ev=>ev.currentTarget.style.background=theme.bgInput}>
                  <div style={{ width:10, height:10, borderRadius:2, background:STAGE_COLORS[e.stage]||"#579bfc", flexShrink:0, marginTop:3 }}/>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:13, fontWeight:600, color:theme.text }}>{e.nome}</div>
                    {e.empresa&&<div style={{ fontSize:12, color:theme.textMuted }}>{e.empresa}</div>}
                    {e.followup?.descricao&&<div style={{ fontSize:12, color:theme.textSub, marginTop:2 }}>{e.followup.descricao}</div>}
                  </div>
                  <div style={{ fontSize:11, color:theme.textMuted, flexShrink:0 }}>
                    {new Date(e.followup.data).toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"})}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Painel lateral */}
        <div style={{ display:"flex", flexDirection:"column", gap:16 }}>

          {/* Próximos follow-ups */}
          <div style={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:12, padding:16 }}>
            <div style={{ fontSize:12, fontWeight:700, color:theme.textMuted, letterSpacing:".06em", textTransform:"uppercase", marginBottom:12 }}>Próximos follow-ups</div>
            {proximos.length===0&&(
              <div style={{ fontSize:13, color:theme.textMuted, textAlign:"center", padding:"20px 0" }}>Nenhum follow-up agendado</div>
            )}
            {proximos.map(l=>{
              const d=new Date(l.followup.data);
              const diff=Math.ceil((d-hoje)/(1000*60*60*24));
              const cor=diff<0?"#e2445c":diff===0?ORANGE:"#00c875";
              return (
                <div key={l._id} onClick={()=>onAbrirLead&&onAbrirLead(l._id)}
                  style={{ display:"flex", gap:10, padding:"8px 0", borderBottom:`1px solid ${theme.border}`, cursor:"pointer" }}
                  onMouseEnter={e=>e.currentTarget.style.background=theme.bgHover}
                  onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                  <div style={{ width:36, height:36, borderRadius:8, background:cor+"18", border:`1px solid ${cor}33`, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                    <div style={{ fontSize:14, fontWeight:800, color:cor, lineHeight:1 }}>{d.getDate()}</div>
                    <div style={{ fontSize:9, color:cor, fontWeight:600 }}>{MESES[d.getMonth()].slice(0,3).toUpperCase()}</div>
                  </div>
                  <div style={{ flex:1, overflow:"hidden" }}>
                    <div style={{ fontSize:13, fontWeight:600, color:theme.text, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{l.nome}</div>
                    <div style={{ fontSize:11, color:diff<0?"#e2445c":diff===0?ORANGE:theme.textMuted }}>
                      {diff<0?`${Math.abs(diff)}d atrasado`:diff===0?"Hoje":`em ${diff}d`}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Legenda */}
          <div style={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:12, padding:16 }}>
            <div style={{ fontSize:12, fontWeight:700, color:theme.textMuted, letterSpacing:".06em", textTransform:"uppercase", marginBottom:12 }}>Etapas</div>
            {Object.entries(STAGE_COLORS).map(([stage,color])=>(
              <div key={stage} style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                <div style={{ width:10, height:10, borderRadius:2, background:color, flexShrink:0 }}/>
                <span style={{ fontSize:12, color:theme.textSub, textTransform:"capitalize" }}>{stage.replace("_"," ")}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
